module.exports = __webpack_public_path__ + "img/fotokino10.69def97c.jpeg";